import { createStore } from 'vuex'
import auth from './modules/auth'
import api from './modules/api'

export default createStore({
  modules: {
    auth,
    api
  },
  
  state: {
    // 全局loading状态
    globalLoading: false,
    
    // 侧边栏折叠状态
    sidebarCollapsed: false,
    
    // 主题设置
    theme: 'light'
  },
  
  getters: {
    globalLoading: state => state.globalLoading,
    sidebarCollapsed: state => state.sidebarCollapsed,
    theme: state => state.theme
  },
  
  mutations: {
    SET_GLOBAL_LOADING(state, loading) {
      state.globalLoading = loading
    },
    
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
    
    SET_SIDEBAR_COLLAPSED(state, collapsed) {
      state.sidebarCollapsed = collapsed
    },
    
    SET_THEME(state, theme) {
      state.theme = theme
    }
  },
  
  actions: {
    setGlobalLoading({ commit }, loading) {
      commit('SET_GLOBAL_LOADING', loading)
    },
    
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    
    setSidebarCollapsed({ commit }, collapsed) {
      commit('SET_SIDEBAR_COLLAPSED', collapsed)
    },
    
    setTheme({ commit }, theme) {
      commit('SET_THEME', theme)
    }
  }
})
